export {
  default,
  ModalBody,
  ModalFooter,
  ModalTabs,
  ModalTabItem,
} from './Modal';
